<template>
  <div v-show="display" class="container-fluid m-0 p-0 loader-component">
    <b-spinner class="spinner" variant="warning" type="grow" label="Spinning"><img width="150" class="loader-image" alt="logo" src="https://admin.panino.am/logo"></b-spinner>
  </div>
</template>

<script>
export default {
  name: "LoaderComponent",
  data(){
    return {
      display: true
    }
  },
  methods: {
    hide(){
      this.display = false
    },
    show(){
      this.display = true
    }
  }
}
</script>

<style scoped>
.loader-component{
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 2000;
  background-color: rgba(128, 128, 128, 0.5);
}
.spinner{
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/LoaderComponent.vue